/**
 * @module @repo/global-login-sdk/protocol
 * Kontrakt des Login-Popups: Nachrichten-Typ + Erfolgs-Nachricht, die die
 * zentrale Login-App per `postMessage` an den Opener schickt und die
 * `loginPopup` akzeptiert. Eine SSOT für beide Seiten (SDK-Listener + Login-App).
 */

/** Fixer `type`-Diskriminator der Popup-Nachricht. */
export const LOGIN_MESSAGE_TYPE = 'gmolike-login' as const;

/** Erfolgs-Nachricht des Login-Popups an den Opener. */
export interface LoginSuccessMessage {
  readonly type: typeof LOGIN_MESSAGE_TYPE;
  readonly ok: true;
}

/** Fixe Erfolgs-Nachricht (Kontrakt-SSOT beider Seiten). */
export const LOGIN_SUCCESS_MESSAGE: LoginSuccessMessage = {
  type: LOGIN_MESSAGE_TYPE,
  ok: true,
};
